import React from 'react';

import { createStyles, Drawer, Stack, Text } from '@mantine/core';
import { AthleteAppointmentWithAthlete, AthleteKiloClassWithAthlete } from 'types';

const useStyles = createStyles(theme => ({
  drawer: {
    justifyContent: 'flex-start',
  },
  hoverText: {
    color: theme.colors.gray[7],
    '&:hover': {
      color: theme.colors.blue[6],
      cursor: 'pointer',
    },
  },
}));

interface IReservationStatusDrawerProps {
  opened: boolean;
  athleteKiloClass?: AthleteKiloClassWithAthlete;
  athleteAppointment?: AthleteAppointmentWithAthlete;
  handleUpdate: () => void;
  handleLateCancel: () => void;
  handleNoShow: () => void;
  closeDrawer: () => void;
}

const ReservationStatusDrawer = ({
  opened,
  athleteKiloClass,
  athleteAppointment,
  handleUpdate,
  handleLateCancel,
  handleNoShow,
  closeDrawer,
}: IReservationStatusDrawerProps): JSX.Element => {
  const { classes } = useStyles();
  const handleLateCancelClick = (): void => {
    handleLateCancel();
    closeDrawer();
  };
  const handleNoShowClick = (): void => {
    handleNoShow();
    closeDrawer();
  };

  return (
    <Drawer
      opened={opened}
      onClose={closeDrawer}
      padding='md'
      size={250}
      position='bottom'
      className={classes.drawer}
    >
      <Stack spacing='lg'>
        <Text align='center' className={classes.hoverText} fw={700} onClick={() => handleUpdate()}>
          {athleteKiloClass?.isCheckedIn || athleteAppointment?.isCheckedIn
            ? 'Mark Unattended'
            : 'Mark Attended'}
        </Text>
        {!athleteKiloClass?.isCheckedIn && !athleteAppointment?.isCheckedIn && (
          <Text
            align='center'
            className={classes.hoverText}
            fw={700}
            onClick={() => handleLateCancelClick()}
          >
            Mark Late Cancelled
          </Text>
        )}
        {!athleteKiloClass?.isCheckedIn && !athleteAppointment?.isCheckedIn && (
          <Text align='center' className={classes.hoverText} fw={700} onClick={() => handleNoShowClick()}>
            Mark No-Show
          </Text>
        )}
      </Stack>
    </Drawer>
  );
};

export default ReservationStatusDrawer;
